import { useContext } from "react";
import { AdaptivityContext } from "../styles/adaptivity";

export const useIsMobile = (): boolean => {
    const { deviceType } = useContext(AdaptivityContext);
  
    return deviceType === 'mobile';
  };